import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import AddressInput from "../../../components/AddressInput";
import TextInput from "../../../components/TextInput";

import Row from "../../../components/Row";
import useERC20Allowance from "../../../hooks/useERC20Allowance";
//import { MINI_POOL_ADDRESS } from "../../../constants/address";
import { USERS_ADDRESS } from "../../../constants/address";
import useERC20Approve from "../../../hooks/useERC20Approve";
import { useWallet } from "use-wallet";
import MultiSelect from "../../../components/MultiSelect";
import { BusinessTypeA, AppTypeA } from "../../../constants/dict";
import { ButtonLight, ButtonPrimary } from "../../../components/Button";
import Loader from "../../../components/Loader";
import useERC20Balance from "../../../hooks/useERC20Balance";
import { fromAmount, toAmount } from "../../../utils/amount";
import Big from "big.js";
import { ZERO_ADDRESS } from "../../../utils/ethereum";
const InputNumerical = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputText = styled(TextInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function UpdatePkgModal({
  isOpen,
  setIsOpen,
  minPledge,
  userOpt,
  token,
  pkgitem,
}) {
  // versionid,appid,version,softtype,updatetag,docsurl,ext

  const [loading, setLoading] = useState(false);
  const [pkgid, setPkgid] = useState("");
  const [price, setPrice] = useState("");
  const [pkgdays, setPkgdays] = useState("");
  const [appgroup, setAppgroup] = useState("");
  const [businesstype, setBusinesstype] = useState("");
  const [daymaxcount, setDaymaxcount] = useState("");
  const [desc, setDesc] = useState("");
  const [ext, setExt] = useState("");
  const [name, setName] = useState("");
  useEffect(() => {
    if (pkgitem && token) {
      setPkgid(pkgitem.pkgid);
      setPrice(toAmount(pkgitem.price || 0, token.decimals || 18));
      setPkgdays(pkgitem.pkgdays);
      setAppgroup(pkgitem.appgroup.join(", "));
      setBusinesstype(pkgitem.businesstype.join(", "));
      setDaymaxcount(pkgitem.daymaxcount);
      setDesc(pkgitem.desc);
      setExt(pkgitem.ext);
      setName(pkgitem.name);
    } else {
      setPkgid("");
      setPrice("");
      setPkgdays("");
      setAppgroup("");
      setBusinesstype("");
      setDaymaxcount("");
      setDesc("");
      setExt("");
      setName("");
    }
  }, [pkgitem, token]);

  const handleOnPledge = useCallback(async () => {
    const ethprice = fromAmount(price, token.decimals || 18);
    const tmpappgroup = appgroup.split(",").map((item) => 1 * item);

    const tmpbusinesstype = businesstype.split(",").map((item) => 1 * item);
    await userOpt.UpdatePkg(
      [pkgid],
      [ethprice],
      [pkgdays],
      [[tmpappgroup]],
      [[tmpbusinesstype]],
      [daymaxcount],
      [""],
      [desc],
      [""],
      [ZERO_ADDRESS],
      setLoading
    );
  }, [
    appgroup,
    businesstype,
    daymaxcount,
    desc,
    userOpt,
    pkgdays,
    pkgid,
    price,
    token,
  ]);

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
      <ModalWrapper
        title={
          <>
            <Trans>Update Pkg</Trans>
            {pkgid > 0 ? pkgid : ""}
          </>
        }
        toggleWalletModal={() => setIsOpen(false)}
      >
        <AutoColumn gap={"24px"}>
          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>name</Trans>
            </LabelWrapper>
            <Row>
              <InputText placeholder=" " value={name} onUserInput={setName} />
            </Row>
          </AutoColumn>

          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>price</Trans>
            </LabelWrapper>
            <Row>
              <InputNumerical
                placeholder=" "
                value={price}
                onUserInput={setPrice}
              />
            </Row>
          </AutoColumn>
          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>pkgdays</Trans>
            </LabelWrapper>
            <Row>
              <InputNumerical
                placeholder="180"
                value={pkgdays}
                onUserInput={setPkgdays}
              />
            </Row>
          </AutoColumn>

          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>appgroup</Trans>
            </LabelWrapper>
            <Row>
              <InputText
                placeholder=""
                value={appgroup}
                onUserInput={setAppgroup}
              />
            </Row>
          </AutoColumn>
          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>businesstype</Trans>
            </LabelWrapper>

            <MultiSelect
              placeholder=""
              List={BusinessTypeA}
              selectValue={businesstype}
              onUserInput={setBusinesstype}
            />
          </AutoColumn>

          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>daymaxcount</Trans>
            </LabelWrapper>
            <Row>
              <InputNumerical
                placeholder="10000"
                value={daymaxcount}
                onUserInput={setDaymaxcount}
              />
            </Row>
          </AutoColumn>
          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>desc</Trans>
            </LabelWrapper>
            <Row>
              <InputText placeholder=" " value={desc} onUserInput={setDesc} />
            </Row>
          </AutoColumn>

          <ButtonPrimary onClick={handleOnPledge} disabled={loading}>
            {loading && <Loader />} <Trans>Update Package</Trans>
          </ButtonPrimary>
        </AutoColumn>
      </ModalWrapper>
    </Modal>
  );
}

export default UpdatePkgModal;
